import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { ArrowRight } from 'lucide-react';
import { usePortalMode } from '@/hooks/usePortalMode';
import { useMyBookings } from '@/hooks/useMyBookings';
import { isPast } from 'date-fns';

export function BookingsCard() {
  const { bookingsCount, isLoading: modeLoading } = usePortalMode();
  const { bookings, isLoading: bookingsLoading } = useMyBookings();

  const upcomingBookings = bookings.filter(
    (b) => b.status !== 'cancelled' && !isPast(new Date(b.event_start_date))
  );

  if (modeLoading || bookingsLoading) {
    return (
      <Card className="border-border/60 shadow-none">
        <CardContent className="p-5 sm:p-6">
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-4 w-48 mt-2" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Link to="/app/customer/bookings" className="block group">
      <Card className="border-border/60 shadow-none transition-colors hover:border-border">
        <CardContent className="p-5 sm:p-6 flex items-center justify-between gap-4">
          <div className="flex-1 min-w-0">
            {bookingsCount === 0 ? (
              <>
                <p className="font-medium text-foreground">Bokningar</p>
                <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
                  Du har inga bokningar just nu.
                  <br />
                  När du bokar något dyker det upp här.
                </p>
              </>
            ) : (
              <>
                <p className="font-medium text-foreground">
                  {bookingsCount} {bookingsCount === 1 ? 'bokning' : 'bokningar'}
                </p>
                {upcomingBookings.length > 0 && (
                  <p className="text-sm text-muted-foreground mt-1.5 truncate">
                    Nästa: {upcomingBookings[0].event_title}
                  </p>
                )}
              </>
            )}
          </div>
          <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground/40 opacity-0 group-hover:opacity-100 transition-opacity" />
        </CardContent>
      </Card>
    </Link>
  );
}
